<template>
  <b-overlay :show="isLoading">
    <b-row v-if="surveyDetails">
      <b-col cols="12">
        <b-card>
          <h1 class="mb-3">ویرایش نظرسنجی</h1>
          <b-row>
            <b-col cols="12" md="8">
              <b-form-group label="عنوان نظرسنجی" label-for="title">
                <b-form-input
                  v-model="surveyDetails.name.tilte"
                  id="title"
                  trim
                  placeholder="نحوه تدریس استاد"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
              <b-form-group label="آیا نظرسنجی فعال است؟" label-for="isActive">
                <b-form-checkbox
                  v-model="surveyDetails.name.isActive"
                  id="isActive"
                  switch
                >
                  نظرسنجی فعال است؟ ({{
                    surveyDetails.name.isActive ? "بله" : "خیر"
                  }})
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
          <hr class="my-1" />
          <div class="d-flex align-items-center mb-2">
            <h3>سوال های نظرسنجی</h3>
          </div>

          <b-row>
            <template
              v-if="surveyDetails.body && surveyDetails.body.length > 0"
            >
              <b-col
                class="my-1"
                cols="12"
                v-for="(question, index) in surveyDetails.body"
                :key="index"
              >
                <single-question-form
                  :questionDetails="question"
                  :questionIndex="index"
                  :isUpdating="true"
                  @removeQuestionFromList="removeQuestionFromList"
                ></single-question-form>
              </b-col>
            </template>
            <template v-else>
              <p class="w-100 text-center">هیچ سوالی جهت نمایش وجود ندارد.</p>
            </template>
          </b-row>
          <b-row>
            <b-col cols="12">
              <div class="w-100 d-flex align-items-center justify-content-end">
                <b-button
                  type="button"
                  variant="success"
                  @click="updateASingleSurvey"
                >
                  ویرایش
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>
<script>
export default {
  mounted() {
    this.getASingleSurvey();
  },
  data() {
    return {
      isLoading: false,
      surveyDetails: null,
    };
  },
  methods: {
    removeQuestionFromList(index) {
      this.surveyDetails.body.splice(index, 1);
    },
    addNewQuestionsToSurvey() {
      this.surveyDetails.body.push({
        questionTitle: null,
        responses: [
          {
            answerValue: 1,
            answer: null,
            imageUrl: null,
            extraClass: null,
            extraStyle: null,
            guide: null,
          },
          {
            answerValue: 2,
            answer: null,
            imageUrl: null,
            extraClass: null,
            extraStyle: null,
            guide: null,
          },
          {
            answerValue: 3,
            answer: null,
            imageUrl: null,
            extraClass: null,
            extraStyle: null,
            guide: null,
          },
        ],
      });
    },
    async updateASingleSurvey() {
      try {
        this.isLoading = true;
        let _this = this;
        let updateASurvey = new UpdateASurvey(_this);
        updateASurvey.setRequestParam({ surveyId: _this.$route.params.id });
        updateASurvey.setRequestParamDataObj(_this.surveyDetails);
        await updateASurvey.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "نظرسنجی با موفقیت ویرایش شد.",
              },
            });
            _this.getASingleSurvey();
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش نشد!",
                icon: "AlertCircleIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد!",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getASingleSurvey() {
      try {
        this.isLoading = true;
        let _this = this;
        let getSurveyById = new GetSurveyById(_this);
        getSurveyById.setRequestParam({
          surveyId: _this.$route.params.id,
        });
        await getSurveyById.fetch((res) => {
          _this.surveyDetails = res.data;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BButton,
    BOverlay,
    SingleQuestionForm,
  },
};
import {
  BCard,
  BRow,
  BCol,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BButton,
  BOverlay,
} from "bootstrap-vue";
import { GetSurveyById } from "@/libs/Api/SurveySurveyQuestion";
import { UpdateASurvey } from "@/libs/Api/SuveyUserSurvey";
import SingleQuestionForm from "./SingleQuestionForm.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
</script>
